const CommonErrorCodes = {
  COM00001: 'an unexpected error occured',
} as const;

export default CommonErrorCodes;
